export default __webpack_public_path__ + "static/media/conversation.66f9a21d.png";